export enum Permiso {
    ReadRubros = "ReadRubros",
    WriteRubros = "WriteRubros",
    ReadPersonas = "ReadPersonas",
    WritePersonas = "WritePersonas",
    ReadProveedores = "ReadProveedores",
    WriteProveedores = "WriteProveedores",
    ReadClientes = "ReadClientes",
    WriteClientes = "WriteClientes",
    ReadVendedores = "ReadVendedores",
    WriteVendedores = "WriteVendedores",
    ReadCuentaCorrientes = "ReadCuentaCorrientes",
    WriteCuentaCorrientes = "WriteCuentaCorrientes",

    //Inventario
    ReadArticulos = "ReadArticulos",
    ReadArticuloHistorial = "ReadArticuloHistorial",
    WriteArticulos = "WriteArticulos",
    WriteArticulosCantidad = "WriteArticulosCantidad",
    ReadCompras = "ReadCompras",
    WriteCompras = "WriteCompras",
    ReadVentas = "ReadVentas",
    ReadUnpaidVentas = "ReadUnpaidVentas",
    WriteVentas = "WriteVentas",
    AllowNegativeStock = "AllowNegativeStock",
    ReadArticuloTransferencias = "ReadArticuloTransferencias",
    WriteArticuloTransferencias = "WriteArticuloTransferencias",
    ReadArticuloMovimientos = "ReadArticuloMovimientos",
    WriteArticuloMovimientos = "WriteArticuloMovimientos",

    //Caja
    ReadCajas = "ReadCajas",
    WriteCajas = "WriteCajas",
    ReadMovimientoCajas = "ReadMovimientoCajas",
    WriteMovimientoCajas = "WriteMovimientoCajas",
    AperturaCierreCajas = "AperturaCierreCajas",
    HistorialAperturaCajas = "HistorialAperturaCajas",
    HistorialAperturaCajaActual = "HistorialAperturaCajaActual",
    AsignarCajas = "AsignarCajas",
    PagarVenta = "PagarVenta",

    //Administracion
    ManageUsuarios = "ManageUsuarios",
    ManagePermisos = "ManagePermisos",
    Auditoria = "Auditoria",
    ManageConfiguracion = "ManageConfiguracion",
    ManageParams = "ManageParams",
    ManageMonetizacion = "ManageMonetizacion",
    ManageOrganizaciones = "ManageOrganizaciones",

    //Reportes
    ReporteVentas = "ReporteVentas",
    ReporteVentaItems = "ReporteVentaItems",
    ReadDashboardFinanciero = "ReadDashboardFinanciero",

    //Monetizacion
    ManageCotizacion = "ManageCotizacion",
    ManageMonedas = "ManageMonedas",
    ManageTransferenciaMetodos = "ManageTransferenciaMetodos",

    // Facturación Electrónica
    ReadDocumentosElectronicos = "ReadDocumentosElectronicos",
    WriteDocumentosElectronicos = "WriteDocumentosElectronicos",
    SendDocumentosElectronicos = "SendDocumentosElectronicos",
    DeleteDocumentosElectronicos = "DeleteDocumentosElectronicos",
    ReservarDocumentosElectronicos = "ReservarDocumentosElectronicos",
    ManageDocumentosElectronicosPendientes = "ManageDocumentosElectronicosPendientes",
    ReadEmisores = "ReadEmisores",
    WriteEmisores = "WriteEmisores",
    ManageConfiguracionFacturacionElectronica = "ManageConfiguracionFacturacionElectronica",
    SendEmails = "SendEmails",

    // Actividades Comerciales
    ReadActividadesComerciales = "ReadActividadesComerciales",
    WriteActividadesComerciales = "WriteActividadesComerciales",

    //localidades
    WriteCiudadesAndBarrios = "WriteCiudadesAndBarrios",
    ReadCiudadesAndBarrios = "ReadCiudadesAndBarrios",
    WritePaises = "WritePaises",
    ReadPaises = "ReadPaises",
    WriteDepartamentos = "WriteDepartamentos",
    ReadDepartamentos = "ReadDepartamentos",
}
